'use client';

import '@/styles/globals.css';
import { BrandMark } from '@/components/ui/BrandMark';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

/**
 * Fallback de error del **root layout** (FEATURE-031). Renderiza su propio
 * `<html><body>` y va sin next-intl ni providers (puede dispararse antes de
 * montarse). Importa `globals.css` para tener los tokens; el `BrandMark` usa
 * colores literales, así que se ve correcto aunque falle el tema.
 */
export default function GlobalError({ error, reset }: GlobalErrorProps) {
  const errorMessage = error.message
    ? error.message.slice(0, 200) + (error.message.length > 200 ? '...' : '')
    : 'Ocurrió un error inesperado';

  return (
    <html lang="es">
      <body>
        <main data-theme="dark" className="min-h-screen bg-bg text-ink grid place-items-center p-4">
          <div className="max-w-md w-full bg-panel border border-line rounded-2xl shadow-lg p-8 text-center">
            <BrandMark size={72} className="mx-auto mb-6" />
            <h1 className="font-display text-xl mb-3">Algo salió mal</h1>
            <p className="text-muted text-sm mb-8 break-words">{errorMessage}</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                type="button"
                onClick={reset}
                className="px-5 py-2.5 rounded-lg font-bold bg-accent text-onbright hover:opacity-90 transition cursor-pointer"
              >
                Reintentar
              </button>
              <button
                type="button"
                onClick={() => (window.location.href = '/')}
                className="px-5 py-2.5 rounded-lg font-bold bg-panel-2 border border-line text-ink hover:border-accent/60 transition cursor-pointer"
              >
                Ir al inicio
              </button>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
